import {Component, Injector, Input, OnDestroy, OnInit} from '@angular/core';
import { BaseDialogTemplateComponent } from '../base-dialog-template.component';
import {VisualizationMode} from '../../../../../shared/enums/visualization-mode.enum';
import {Panel} from '../../../../../shared/models/visualization/panel.model';
import {HealthCase} from '../../../../../shared/models/healthCase.model';
import {ContextService} from '../../../../../core/services/http/context.service';
import { EventService } from 'app/core/services/event.service';
import { UrukTemporalQuery } from 'app/shared/models/query/uruk-temporal-query.model';
import { DefibrillatorService } from 'app/core/services/defibrillator.service';

@Component({
  selector: 'drone-template',
  templateUrl: './drone-template.component.html',
  styleUrls: ['./drone-template.component.scss']
})

export class DroneTemplateComponent extends BaseDialogTemplateComponent implements OnInit, OnDestroy {

  entity: any;
  positionEntity: any;
  brand: string;
  description: string;
  showFooter: boolean = true;
  activeTab: string;
  dialogViewportMin: number;
  VisualizationMode = VisualizationMode;
  droneId: number;
  colorSignalQuality: string;
  positionStatus: number;
  showSignalQuality: boolean = true;
  model: string;
  serialNumber: string;
  certificateDate: string;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.dialogViewportMin = Math.min(this.layoutService.getApplicationSize()[0], this.layoutService.getApplicationSize()[1]) / 4;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public onTabChange(event) {
    this.activeTab = event.tabId;
  }



  protected mapContextData(context: any): void {
    this.entity = context.entity.entity ? context.entity.entity : undefined;
    this.positionEntity = context.positionEntity.entity;
    this.droneId = this.entity.id.split(':')[3];
    this.brand = this.entity.brand.value;
    this.model = this.entity.model.value;
    this.serialNumber = this.entity.serialNumber.value;
    this.certificateDate = this.entity.certificateDate.value;
    this.positionStatus = this.positionEntity.status ? this.positionEntity.status.value : -1;
  }
}
